import { render, staticRenderFns } from "./Notice.vue?vue&type=template&id=2af037d1&scoped=true"
import script from "./Notice.vue?vue&type=script&lang=js"
export * from "./Notice.vue?vue&type=script&lang=js"
import style0 from "./Notice.vue?vue&type=style&index=0&id=2af037d1&prod&lang=css"
import style1 from "./Notice.vue?vue&type=style&index=1&id=2af037d1&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2af037d1",
  null
  
)

export default component.exports